/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseDTOTierDetailDTO } from '../models/ApiResponseDTOTierDetailDTO';
import type { ApiResponseDTOTransactionPinDetailDTO } from '../models/ApiResponseDTOTransactionPinDetailDTO';
import type { ApiResponseDTOWalletBalanceInfoResponseDTO } from '../models/ApiResponseDTOWalletBalanceInfoResponseDTO';
import type { ApiResponseDTOWalletHolderInfoResponseDTO } from '../models/ApiResponseDTOWalletHolderInfoResponseDTO';
import type { TransactionPinDTO } from '../models/TransactionPinDTO';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class WalletApiService {

    /**
     * Get Wallet details
     * API used to get the Wallet details
     * @returns ApiResponseDTOWalletBalanceInfoResponseDTO OK
     * @throws ApiError
     */
    public static getWalletDetails(): CancelablePromise<ApiResponseDTOWalletBalanceInfoResponseDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/wallet',
            errors: {
                404: `Not Found`,
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Create Transaction Pin
     * API used to Create the transaction PIN
     * @param requestBody
     * @returns ApiResponseDTOTransactionPinDetailDTO OK
     * @throws ApiError
     */
    public static createTransactionPin(
        requestBody: TransactionPinDTO,
    ): CancelablePromise<ApiResponseDTOTransactionPinDetailDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/wallet/pin',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Not Found`,
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Change Transaction Pin
     * API used to change the transaction PIN
     * @param requestBody
     * @returns ApiResponseDTOTransactionPinDetailDTO OK
     * @throws ApiError
     */
    public static changeTransactionPin(
        requestBody: TransactionPinDTO,
    ): CancelablePromise<ApiResponseDTOTransactionPinDetailDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/wallet/pin/change',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Not Found`,
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Validate Transaction Pin
     * API used to validate the transaction PIN
     * @param requestBody
     * @returns ApiResponseDTOTransactionPinDetailDTO OK
     * @throws ApiError
     */
    public static validateTransactionPin(
        requestBody: TransactionPinDTO,
    ): CancelablePromise<ApiResponseDTOTransactionPinDetailDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/wallet/pin/validate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Not Found`,
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Verify the transaction PIN without minting a token
     * Checks the current PIN for a settings journey. Charges and enforces the existing attempt lockout but issues no X-MFA token.
     * @param requestBody
     * @returns ApiResponseDTOTransactionPinDetailDTO OK
     * @throws ApiError
     */
    public static verifyTransactionPin(
        requestBody: TransactionPinDTO,
    ): CancelablePromise<ApiResponseDTOTransactionPinDetailDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/wallet/pin/verify',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Get wallet tier level
     * API used to retrieve the wallet tier level information
     * @returns ApiResponseDTOTierDetailDTO OK
     * @throws ApiError
     */
    public static getWalletTierLevel(): CancelablePromise<ApiResponseDTOTierDetailDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/wallet/tier',
            errors: {
                404: `Not Found`,
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Get Wallet holder details
     * API used to get the Wallet holder details
     * @param walletId
     * @returns ApiResponseDTOWalletHolderInfoResponseDTO OK
     * @throws ApiError
     */
    public static getWalletHolderInfo(
        walletId: string,
    ): CancelablePromise<ApiResponseDTOWalletHolderInfoResponseDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/wallet/{walletId}/holder',
            path: {
                'walletId': walletId,
            },
            errors: {
                404: `Not Found`,
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

}
